import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="border-y border-primary/30 py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-73" data-mp="4vs0rz0u8fre">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-74" data-mp="9srx3i7vy45b">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-3xl border-2 border-accent/80 bg-background/90 p-8 shadow-2xl shadow-black/40 sm:p-12" data-id="element-75" data-mp="etz5njhur7d1">
          <span className="inline-flex rounded-full border border-highlight/50 bg-surface p-4 text-highlight" data-id="element-76" data-mp="smxf29r4qzzl">
            <ShieldCheckIcon className="glow-led h-10 w-10" aria-hidden="true" data-id="element-77" data-mp="xlrzth8nqymc" />
          </span>
          <h2 id="guarantee-title" className="mt-6 font-display text-4xl font-extrabold uppercase tracking-tight text-foreground sm:text-5xl" data-id="element-78" data-mp="12h78zvvq06cf">
            7-Day <span className="text-accent" data-id="element-79" data-mp="25syiyof03af4">Guarantee</span>
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-muted" data-id="element-80" data-mp="20sawmg1pvhr8">
            Study all 6 volumes and 5 bonuses this week. If the technical depth doesn&apos;t match your professional
            needs,{' '}
            <span className="font-extrabold text-accent" data-id="element-81" data-mp="1rsnx5zsjsm0t">we refund 100%. No questions. No complications.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}